module.exports = __webpack_public_path__ + "static/media/moonbeam.1d98129d.svg";